export enum EventNotificationBarEnum {
    closed = 'NotificationBar geschlossen',
    ctaButtonClicked = 'CTA-Button geklickt',
}
